"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hex_1 = require("@stablelib/hex");
const hex = {
    encode: function HexEncode(input) {
        if (typeof Buffer !== 'undefined') {
            return Buffer.from(input, 0, input.length).toString('hex');
        }
        const lowerCase = true;
        return (0, hex_1.encode)(input, lowerCase);
    },
    decode: function HexDecode(input) {
        if (input.length % 2 !== 0) {
            input = '0' + input;
        }
        if (typeof Buffer !== 'undefined') {
            const buf = Buffer.from(input, 'hex');
            return new Uint8Array(buf, 0, buf.length);
        }
        return (0, hex_1.decode)(input);
    }
};
exports.default = hex;
